<template>
  <main class='container'>
    <sh-navbar
      :tab-title="tabTitle"
      :current-tab-index="currentTabIndex"
      :scroll-disabled="scrollDisabled"
      @tabChange="tabChange"
      @loadMore="loadMore">
        <buy-user-item
          v-if="dataList.length > 0 && currentTabIndex === 0"
          slot="tab-cnt0"
          :data-list="dataList"
          :data-info="dataInfo">
        </buy-user-item>
        <register-item
          v-if="dataList.length > 0 && currentTabIndex === 1"
          slot="tab-cnt1"
          :data-list="dataList">
        </register-item>
    </sh-navbar>
    <segement-Line
      v-if="!haveMore"
      line-text="没有更多记录了">
    </segement-Line>
    <segement-Line
      v-else
      :is-load="true">
    </segement-Line>
  </main>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { MSappListByPartnerCode, RecommendRegisterList } from '@/api/partner'
import ShNavbar from '@/components/smartComponent/SHnavbar'
import BuyUserItem from './children/BuyUserItem'
import RegisterItem from './children/RegisterItem'
import SegementLine from '@/components/puppetComponent/SegementLine'
import moment from 'moment'
export default {
  data () {
    return {
      tabTitle: ['已下单好友', '已注册好友'],
      haveMore: true,
      scrollDisabled: false,
      dataInfo: {},
      dataList: [],
      currentTabIndex: 0,
      currentPage: 1,
      page: 1,
      pageCount: 1
    }
  },
  components: {
    SegementLine,
    ShNavbar,
    BuyUserItem,
    RegisterItem
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = { page: this.currentPage }
      this.scrollDisabled = true
      if (this.currentTabIndex === 0) {
        // 下单好友数据
        MSappListByPartnerCode(params).then(res => {
          this.dataInfo = res
          this.handleSuccess(res)
        }).catch(err => {
          this.handlerErr(err)
        })
      } else {
        // 注册好友数据
        RecommendRegisterList(params).then(res => {
          this.handleSuccess(res)
        }).catch(err => {
          this.handlerErr(err)
        })
      }
    },
    handleSuccess (res) {
      Indicator.close()
      this.dataList = [...this.dataList, ...res.DataList]
      this.page = res.PaginationViewModel.Page
      this.pageCount = res.PaginationViewModel.PageCount
      this.haveMore = false
      if (this.page >= this.pageCount) this.haveMore = false
      this.scrollDisabled = false
    },
    handlerErr (err) {
      Indicator.close()
      this.haveMore = false
      Toast(err.ErrMsg)
    },
    tabChange (val) {
      this.currentTabIndex = val
      this.dataList = []
      this.currentPage = 1
      this.haveMore = true
      this.$router.replace({ name: 'recommendFriend', query: { tabIndex: val } })
      this.fetchData()
    },
    loadMore () {
      let { currentPage, page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage = currentPage + 1
      this.haveMore = true
      this.fetchData()
    }
  },
  filters: {
    formatTime (val) {
      return moment(val).format('YYYY-MM-DD')
    },
    phoneEncode (val) {
      if (!val) {
        return '----'
      }
      let star = val.substring(0, 3)
      let end = val.substring(val.length - 4, val.length)
      return star + '****' + end
    }
  }
}
</script>
